/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SocialModal from 'app/components/SocialModal/SocialModal.jsx';
import * as _ from 'underscore';

export default function ImporterModule(WrappedComponent) {
    return class ImporterModule extends WrappedComponent {
        constructor(props) {
            super(props);

            this.onAddSocial = this.onAddSocial.bind(this);
            this.onChooseSocials = this.onChooseSocials.bind(this);
            this.onSocialsSelected = this.onSocialsSelected.bind(this);
            this.onImportItems = this.onImportItems.bind(this);

        }

        onAddSocial(e, noTwitter) {

            let appUrl = this.props.app.config.appUrl,
                modal = (
                    <SocialModal
                        {...this.props}
                        setModal={this.props.closeAllModals}
                        router={this.props.router}
                        context={'config'}
                        recordPath={this.props.recordPath}
                        redirect={appUrl + "/content/import"}
                        noTwitter={noTwitter}/>

                );

            e.preventDefault();

            this.props.addModal(modal);

        }

        onChooseSocials(e, noTwitter) {

            let modal = (
                <SocialModal
                    {...this.props}
                    setModal={this.props.closeAllModals}
                    router={this.props.router}
                    context='bulk-modal'
                    activeTab='chooseAcct'
                    onSocialsSelected={this.onSocialsSelected}
                    selectedSocials={this.state.selectedSocials}
                    singleTwitter={true}
                    noTwitter={noTwitter}/>
            );

            e.preventDefault();

            this.props.addModal(modal);

        }

        onSocialsSelected(socials) {

            this.setState({
                selectedSocials: socials,
            }, () => {
                this.props.closeAllModals();
            });

        }

        onImportItems(items, params) {

            let socials = _.clone(this.state.selectedSocials);

            if (this.state.importComplete) {
                this.setState({
                    importComplete: false
                });
            }

            this.props.deleteApiError(['BULK_POST']);
            this.props.postBulkItems(items, params, socials);

        }

        render() {

            return super.render();

        }
    }
}
